import { CustomField } from "aderant-conflicts-models";
import React from "react";
import { FieldWrapper } from "./FieldWrapper";

interface CustomInformationProps {
    field: CustomField;
}

export const CustomInformation = (props: CustomInformationProps): JSX.Element => {
    const {
        field: { fieldLabel, value }
    } = props;
    
    return (
        <FieldWrapper fieldLabel={fieldLabel}>
            {value}
        </FieldWrapper>
    );
};
